function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "#F92626"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.15622 8.18207L7.15645 8.18194L11.1083 5.89613C11.1085 5.89599 11.1088 5.89586 11.109 5.89572C11.6626 5.57974 12.3386 5.5807 12.8837 5.89539C12.8837 5.8954 12.8838 5.8954 12.8838 5.89541L16.8416 8.18081C16.8419 8.18102 16.8423 8.18122 16.8426 8.18143C17.3901 8.50364 17.7281 9.08415 17.7342 9.72146V14.2799C17.7342 14.9175 17.3957 15.503 16.8504 15.8178L16.8504 15.8178L12.8917 18.1037C12.8915 18.1038 12.8913 18.104 12.891 18.1041C12.3375 18.4201 11.6614 18.4192 11.1162 18.1044C11.1162 18.1044 11.1162 18.1044 11.1162 18.1044L7.15838 15.819C7.15804 15.8188 7.1577 15.8186 7.15736 15.8184C6.60979 15.4962 6.27246 14.9094 6.27246 14.2799V9.71992C6.27246 9.08232 6.61093 8.49688 7.15622 8.18207ZM12.7037 15.537L12.7098 15.5309L12.7155 15.5245C12.7992 15.4315 12.8661 15.327 12.9141 15.2119C12.9613 15.0986 12.9925 14.9693 12.9925 14.8333C12.9925 14.6988 12.962 14.5711 12.9158 14.4587C12.8643 14.3266 12.7927 14.2277 12.7155 14.142L12.7098 14.1356L12.7037 14.1295C12.426 13.8518 11.9939 13.7612 11.6236 13.9182C11.4924 13.9697 11.3941 14.0409 11.3087 14.1178L11.3023 14.1235L11.2963 14.1295C11.1051 14.3207 11.0075 14.5785 11.0075 14.8333C11.0075 14.9523 11.0257 15.0834 11.0792 15.2119L11.0836 15.2222L11.0886 15.2323C11.1385 15.332 11.2006 15.4313 11.2845 15.5245L11.296 15.5373L11.3087 15.5488C11.3945 15.6259 11.4934 15.6975 11.6255 15.749C11.7378 15.7953 11.8656 15.8257 12 15.8257C12.2632 15.8257 12.5137 15.727 12.7037 15.537ZM12 8.34078C11.5467 8.34078 11.1742 8.71332 11.1742 9.16658V12.6666C11.1742 13.1199 11.5467 13.4924 12 13.4924C12.4533 13.4924 12.8258 13.1199 12.8258 12.6666V9.16658C12.8258 8.71332 12.4533 8.34078 12 8.34078Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.651602
});

var SvgErrorIcon = function SvgErrorIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgErrorIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ErrorIcon.4b5d2a5c.svg";
export { ForwardRef as ReactComponent };